import * as Animate from "react-reveal";

const ShareStorySection = ({ handleShowForm }) => {
  return (
    <section aria-labelledby="share-story-title" className="px-4">
      <Animate.Fade bottom>
        <div
          className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-8 sm:gap-[42px] rounded-[24px] mx-auto"
          style={{
            background: "#fff8e7",
            border: "1px solid #e5d6ab",
            maxWidth: "1228px",
            marginBottom: "24px",
            padding: "42px 44px",
          }}
        >
          <div>
            <p className="text-[#8c5b00] tracking-[0.1em] uppercase text-[15px] font-extrabold mb-2">
              Add Your Voice
            </p>
            <h2
              id="share-story-title"
              className="text-primary tracking-[-0.045em] font-bold max-w-[780px] m-0"
              style={{ fontSize: "clamp(30px, 3.2vw, 44px)", lineHeight: 1.13 }}
            >
              Did Utiva change something in your learning or career journey?
            </h2>
            <span className="text-[#5a6275] max-w-[720px] text-[16px] leading-[1.65] block mt-[13px]">
              Share what happened with the community. Every submission is
              reviewed before anything is published.
            </span>
          </div>
          <button
            type="button"
            onClick={handleShowForm}
            className="flex-none w-full sm:w-auto justify-center bg-primary text-white rounded-[11px] inline-flex items-center gap-[10px] text-[15px] font-extrabold px-[19px]"
            style={{ minHeight: "53px" }}
          >
            Write Your Story <span aria-hidden="true">→</span>
          </button>
        </div>
      </Animate.Fade>
    </section>
  );
};

export default ShareStorySection;
